import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import Iframe from 'react-iframe';
import articalData from '../articalData.json';
import Navbar from '../components/Navbar';
export class Link extends Component {
  render() {
    var data = articalData.find(a => a.id === this.props.id);
    if (data.iframeable === true) {
      return (
        <NavLink to={'/articles/' + data.id} exact>
          {data.name}
        </NavLink>
      );
    } else {
      return <a href={data.href}>{data.name}</a>;
    }
  }
}

export class IframeCustom extends Component {
  render() {
    var data = articalData.find(a => a.id === this.props.match.params.id);
    return (
      <Fragment>
        <Navbar />
        <div id="features" style={{ height: '100vh' }}>
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                {data ? <h2 className="lead text-center">{data.name}</h2> : <h4>Could not find article</h4>}
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12" />
                </div>
              </div>
            </div>
          </div>
          {data && (
            <Iframe
              url={data.href}
              width="100%"
              height="100%"
              id={data.id}
              className="myClassname"
              display="initial"
              position="relative"
              allowFullScreen
            />
          )}
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Iframe.jsx